import styled from 'styled-components';

import { resolveSpacersArray } from 'common/styles/utils';

const TitleContainer = styled.div`
  margin: ${({ theme }) => resolveSpacersArray(theme, [0, 0.5, 0, 2])};
`;

export default TitleContainer;
